'use strict';
module.exports = function withoutExtension(fileName) {
	return fileName && fileName.replace(/\.[^.]+$/, '');
};
